import { Grid } from "@mui/material";
import Booking from "./Booking";
import { Booking as BookingDetails } from "../../models/BookingDetails";

export interface ViewBookingsProps {
  bookings: BookingDetails[];
}

function ViewBookings(props: ViewBookingsProps) {
  return (
    <Grid container sx={{ width: 1, height: 1 }}>
      {props.bookings.map((booking: BookingDetails) => {
        return (
          <Booking booking={booking} key={booking.BookingID} />
        );
      })}
    </Grid>
  );
}

export default ViewBookings;
